import { module } from 'angular';

import {
  default as transferTargetCorrespondentName,
  TransferTargetCorrespondent,
} from './target-correspondent/target-correspondent.component';
import { default as transferTargetCsrName, TransferTargetCsr } from './target-csr/target-csr.component';
import { default as transfertTargetFreeEmail, TransferTargetFreeEmail } from './target-free-email/target-free-email.component';
import { default as transferTargetFreeNumberName, TransferTargetFreeNumber } from './target-free-number/target-free-number.component';
import {
  default as transferTargetSelectionMail,
  TransferTargetSelectionMail,
} from './target-selection/mail/target-selection-mail.component';
import {
  default as transferTargetSelectionVisio,
  TransferTargetSelectionVisio,
} from './target-selection/visio/target-selection-visio.component';
import { default as transferTargetSkillName, TransferTargetSkill } from './target-skill/target-skill.component';
import { default as transferCommentName, TransferComment } from './transfer-comment/transfer-comment.component';
import { default as transferFormName, TransferForm } from './transfer-form.component';

export default module('contact.agent.core.agent.transfer.form', [])
  .component(transferTargetCorrespondentName, new TransferTargetCorrespondent())
  .component(transferTargetCsrName, new TransferTargetCsr())
  .component(transfertTargetFreeEmail, new TransferTargetFreeEmail())
  .component(transferTargetFreeNumberName, new TransferTargetFreeNumber())
  .component(transferTargetSelectionMail, new TransferTargetSelectionMail())
  .component(transferTargetSelectionVisio, new TransferTargetSelectionVisio())
  .component(transferTargetSkillName, new TransferTargetSkill())
  .component(transferCommentName, new TransferComment())
  .component(transferFormName, new TransferForm()).name;
